import { createFileRoute, redirect } from "@tanstack/react-router";
import { CALL_TYPE } from "~/constants/call";
import { AudioInCallTemplate } from "~/features/call/audio/AudioInCallTemplate";
import { useCallStore } from "~/stores/useCallStore";

export const Route = createFileRoute("/_authenticated/call/audio/")({
  staticData: { hideBottomNav: true },
  beforeLoad: () => {
    const { phase, callType } = useCallStore.getState();
    if (phase.type !== "inCall" && phase.type !== "ended") {
      throw redirect({ to: "/discover" });
    }
    if (callType !== CALL_TYPE.VOICE) {
      throw redirect({ to: "/call/video" });
    }
  },
  component: AudioInCallTemplate,
});
